import { alpha, keyframes, styled } from '@mui/material/styles';
import { List } from '@mui/material';

// Dark-mode hover lifts the row with rgba(255,255,255,0.2), so action.selectedOpacity renders the
// flash dimmer than a plain hover over the dark paper. The flash has to out-weigh hover.
const DARK_REVEAL_FLASH_OPACITY = 0.4;

// Held in a custom property so the dark-mode override swaps only the color, rather than restating
// the animation shorthand against a second set of keyframes.
const REVEAL_FLASH_COLOR_VAR = '--ContentExplorerItem-revealFlashColor';

const revealFlash = keyframes`
  from {
    background-color: var(${REVEAL_FLASH_COLOR_VAR});
  }
  to {
    background-color: transparent;
  }
`;

export const StyledContentExplorerList = styled(List)(({ theme }) => ({
  '.MuiListItem-root': {
    '&:hover': {
      '.ContentExplorerItem-date': {
        display: 'inline',
      },
      '.ContentExplorerItem-state': {
        display: 'none',
      },
    },
  },
  '.ContentExplorerItem-revealed': {
    [REVEAL_FLASH_COLOR_VAR]: alpha(
      theme.palette.primary.light,
      theme.palette.action.selectedOpacity
    ),
    ...theme.applyStyles('dark', {
      [REVEAL_FLASH_COLOR_VAR]: alpha(theme.palette.primary.light, DARK_REVEAL_FLASH_OPACITY),
    }),
    animation: `${revealFlash} 1500ms ease-out`,
  },
  '.MuiListItemButton-root': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  '.MuiListItemText-root': {
    margin: 0,
  },
  '.MuiListItemText-secondary': {
    paddingTop: '1px',
    lineHeight: 1.2,
    fontSize: theme.typography.pxToRem(12),
  },
  '.MuiListItemIcon-root': {
    minWidth: 0,
    margin: 0,
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
    '&.ContentExplorerItem-progressIcon': {
      padding: theme.spacing(0.5),
    },
  },
  '.MuiListItemSecondaryAction-root .MuiIconButton-edgeEnd': {
    marginRight: theme.spacing(-2),
  },
  '.ContentExplorerItem-date': {
    display: 'none',
  },
  '.ContentExplorerItem-state': {
    display: 'inline',
  },
}));
